module.exports = __webpack_public_path__ + "static/media/5.b38e87cb.png";